import { render, staticRenderFns } from "./MediaBlock.vue?vue&type=template&id=5820aaa8&"
import script from "./MediaBlock.vue?vue&type=script&lang=js&"
export * from "./MediaBlock.vue?vue&type=script&lang=js&"
import style0 from "./MediaBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports